'use client';

import { c as _c } from "react/compiler-runtime";
import { LucideCircleCheck } from 'lucide-react';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';
export function PreRegisterSuccessState() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Empty className="w-full border border-dashed py-10"><EmptyHeader><EmptyMedia variant="icon"><LucideCircleCheck className="text-primary" /></EmptyMedia><EmptyTitle>Cadastro realizado!</EmptyTitle><EmptyDescription className="max-w-md text-pretty">Em breve a nossa equipe entrará em contato com você. Obrigado pelo interesse no Clube Pormade.</EmptyDescription></EmptyHeader></Empty>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}